/* VMB: Google Reviews by Appio (.agrs__carousel1) – responsive slidesPerView fix.
   Ported from previous theme. The app initialises Swiper with 580:2 / 894:3 / 1200:4
   and no 1-slide rule for phones, so cards overflow on mobile. */
(function () {
  var lastSwiper = null, index = 0;
  setInterval(function () {
    var swiper = window.Google && window.Google.swipers && window.Google.swipers.carousel1;
    if (!swiper || swiper === lastSwiper) return;
    lastSwiper = swiper;
    swiper.on('slideChange', function () { index = swiper.activeIndex; });
    swiper.params.breakpoints = {
      580:  { slidesPerView: 1 },
      894:  { slidesPerView: 2 },
      1200: { slidesPerView: 3 },
      9999: { slidesPerView: 4 }
    };
    swiper.currentBreakpoint = false;
    var keep = index;
    swiper.slideTo(0, 0);
    swiper.update();
    swiper.slideTo(keep, 0);
  }, 500);
})();
